import richTextEditor from "./richTextEditor";

export default [richTextEditor];
